import {
    Button,
    Flex,
    FormControl,
    Tag,
    FormErrorMessage,
    FormLabel,
    Heading,
    Input,
    Link,
    Select,
    Box
} from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import SituacaoJuridicaService from "../../../main/services/SituacaoJuridicaService";
import { Link as ReactLink, useHistory } from 'react-router-dom';
import SemRegistros from '../../components/SemRegistros';
import { useAuthProvider } from '../../../Context/AuthProvider';
import { situacaoJuridica } from '../../../helpers/Funcionalidades'
import { Group } from '../Criancas/Group';



const CadastrarSituacaoJuridica = () => {
    let history = useHistory()
    document.title = 'MCA - Situação Jurídica - Cadastrar'

    const [descricaoCount, setDescricaoCount] = useState(0);
    const { roleKeycloack } = useAuthProvider();

    const validate = (values) => {
        const errors = {};

        if (!values.tipo || values.tipo === "" || values.tipo.trim() === "") {
            errors.tipo = "Tipo de situação jurídica é obrigatório!";
        }

        if (!values.descricao || values.descricao === "" || values.descricao.trim() === "") {
            errors.descricao = "Descrição é obrigatória!";
        }

        return errors;
    };

    return roleKeycloack && roleKeycloack.includes(situacaoJuridica.situacaoJuridicaCadastrar) ? (
        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex
                flexDir="row"
                justifyContent="space-between"
            >

                <Heading fontSize="large">
                    Cadastrar Situação Jurídica
                </Heading>
                <Link as={ReactLink}
                    to="/situacao-juridica/lista"
                    _hover={{ textDecoration: "none" }}
                >
                    <Button colorScheme={"teal"} px={16}>
                        Voltar
                    </Button>
                </Link>
            </Flex>

            <Formik
                validate={validate}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                    descricao: "",
                    tipo: ""
                }}
                onSubmit={(values, actions) => {
                    setTimeout(() => {
                        SituacaoJuridicaService.novaSituacaoJuridica(values).then((res) => {
                            Swal.fire({
                                title: 'Sucesso!',
                                'text': 'Registro cadastrado com sucesso!',
                                icon: 'success',
                                confirmButtonText: 'Continuar',
                                confirmButtonColor: '#169499'
                            }).then(function () {
                                history.push("/situacao-juridica/" + res.data.id);
                            });
                            actions.setSubmitting(false);
                        }).catch((error => {
                            actions.setFieldError(error.response && error.response.data.field, error.response && error.response.data.message)
                            actions.setSubmitting(false);
                        }))

                    }, 200)
                }}>
                {(props) => (
                    <Flex
                        flexDir="column"
                        mt={5}>
                        <Form>
                            <Group bgColor="#fff" title="" py="12px" >
                                <Box width={{ lg: '50%' }}>
                                    <Field name="tipo">
                                        {({ field, form }) => (
                                            <FormControl isInvalid={form.errors.tipo && form.touched.tipo}>
                                                <FormLabel htmlFor="tipo">Tipo de Situação Jurídica*</FormLabel>
                                                <Select
                                                    {...field}
                                                    id="tipo"
                                                    backgroundColor={"white"}
                                                    placeholder={"Selecione o Tipo de Situação Jurídica"}
                                                    h="42px"
                                                >
                                                    <option value={"P"}>Processo</option>
                                                    <option value={"D"}>Procedimento</option>
                                                </Select>
                                                <FormErrorMessage>{form.errors.tipo}</FormErrorMessage>
                                            </FormControl>

                                        )}
                                    </Field>
                                    <Flex mt={5}>
                                        <Field name="descricao">
                                            {({ field, form }) => (
                                                <FormControl isInvalid={form.errors.descricao && form.touched.descricao}>
                                                    <FormLabel htmlFor="descricao">Descrição*</FormLabel>
                                                    <Input
                                                        autoFocus
                                                        backgroundColor="white"
                                                        {...field}
                                                        id="descricao"
                                                        placeholder="Informe a Descrição da Situação Jurídica"
                                                        maxLength={255}
                                                        onChange={(e) => {
                                                            setDescricaoCount(e.target.value.length);
                                                            form.setFieldValue(field.name, e.target.value);
                                                        }}
                                                        h="42px"
                                                    />
                                                    <FormErrorMessage>{form.errors.descricao}</FormErrorMessage>
                                                </FormControl>

                                            )}
                                        </Field>
                                    </Flex>

                                    <Flex flexDirection="row-reverse">
                                        <Tag maxW="max-content">{`${descricaoCount}/255`}</Tag>
                                    </Flex>
                                </Box>
                            </Group>
                            <Flex mt={2} justifyContent="space-between">
                                <Flex></Flex>
                                <Button
                                    mt={4}
                                    colorScheme="teal"
                                    px={16}
                                    isLoading={props.isSubmitting}
                                    type="submit"
                                    translate="no">
                                    Salvar
                                </Button>
                            </Flex>

                        </Form>
                    </Flex>
                )}
            </Formik>
        </Flex>

    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    )
}

export default CadastrarSituacaoJuridica;